// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Storefront48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Storefront48Filled: FC<Storefront48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M42 22.05V39c0 .8-.3 1.5-.9 2.1-.6.6-1.3.9-2.1.9H8.95c-.8 0-1.5-.3-2.1-.9-.6-.6-.9-1.3-.9-2.1V22.05A5.663 5.663 0 0 1 4.1 19.1a6.257 6.257 0 0 1 .1-3.5l2.15-6.75c.267-.9.733-1.6 1.4-2.1.667-.5 1.433-.75 2.3-.75H37.7c.933 0 1.75.258 2.45.775.7.517 1.183 1.208 1.45 2.075l2.2 6.75a6.107 6.107 0 0 1 .075 3.5A5.814 5.814 0 0 1 42 22.05ZM28.5 20.5c.967 0 1.783-.317 2.45-.95.667-.633.933-1.4.8-2.3L30.5 9h-5v8.25c0 .867.283 1.625.85 2.275.567.65 1.283.975 2.15.975Zm-9.35 0c.933 0 1.725-.317 2.375-.95.65-.633.975-1.4.975-2.3V9h-5l-1.25 8.25c-.133.867.1 1.625.7 2.275.6.65 1.333.975 2.2.975Zm-9.1 0c.8 0 1.492-.275 2.075-.825a3.258 3.258 0 0 0 1.025-2.025L14.45 9h-5l-2.3 7.3c-.333 1.033-.2 1.992.4 2.875.6.883 1.433 1.325 2.5 1.325Zm27.85 0c1.067 0 1.908-.433 2.525-1.3s.758-1.833.425-2.9L38.55 9h-5l1.3 8.65c.1.8.442 1.475 1.025 2.025.583.55 1.258.825 2.025.825Z" />
        </svg>
    );
};

export default Storefront48Filled;
